import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  FormBuilder,

  FormControl,

  FormGroup,
  Validators
} from '@angular/forms';
import { TabPosition } from '@progress/kendo-angular-layout';
import { BehaviorSubject, Observable } from 'rxjs';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { UserSummary } from '~/models/administration/user';
import { Chart } from '~/models/chart/chart';
import { CustomFieldSummary } from '~/models/modules/customField';
import { GridFieldSummary } from '~/models/modules/gridField';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { LocationSummary } from '~/models/modules/location';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { StockItemsService } from '~/services/modules/stocks/items';
import { LocationTypesService } from '~/services/modules/stocks/location-types';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService, PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { NoteComponent } from '~/shared/components/note/note.component';
import { FacilityService } from '~/services/modules/stocks/facility';
import { DatePipe, formatDate } from '@angular/common';
import { FormatService } from '~/services/administration.ts/format';

@Component({
    selector: 'app-upsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StocksFacilityUpsertComponent implements OnInit, OnDestroy, AfterContentChecked {
  _deactivatedFormTabsForm: boolean = false
  _deactivatedFormTabsGridData: Array<any> = [];

  _kendoTabStripPosition: TabPosition = 'left';
  _innerWidth: any;
  _hiddenWindow: any;
  _maximized: any;
  _theme: string;
  clearfeiled: BehaviorSubject<any>;
  _form: FormGroup;
  _active: boolean;
  _isAutoGeneratingNumber: boolean;
  _tabEnabled: boolean;
  _currentType: string;
  _invalidForm: boolean;
  _model: LocationSummary;
  _canEditLocationType: boolean = true;
  _locationCode = new FormControl();
  _pageState: PageState;
  _showCirclesForm: boolean;
  _tooltipVisibilityUpsert: boolean = true;
  _tooltipVisibilityForm: boolean = true;
  _addClassActive: boolean = false;
  _isCustomfieldsFormValue: boolean = false;
  _isAddTabFormValue: boolean = false;
  _isRenameFormValue: boolean = false;
  _selectedTabId: number;
  _editFormActive: boolean;
  _customFields: CustomFieldSummary[][] = [];
  _page = 'facility';
  _permissionScope = 'facility';
  _customTabs: any;
  _customFieldsValue: any = [];
  _customValidation: any[] = [];
  _additionalErrors: any[] = [];
  _gridFieldText: GridFieldTextSummary[];
  _language: string = 'en';
  _isRenameLabel: boolean = false;
  _selectedLabelObjectCode: any;
  _isRenameCustomFormValue: boolean = false;
  _selectedLabelId: number;
  _customFieldsDictionary: { [key: string]: string } = {};
  _selectedAccountIds: any[] = [];
  _custominvalidForm: boolean;
  _invalidSubmit: boolean;
  _systemFields: Array<any> = [];
  _editedSystemFields: Array<any> = [];
  _index: number;
  _userNewDataTabs: Array<any> = [];
  _dataTabs: Array<any> = [];
  _dataTabsSelected: Array<any> = [];
  _orderingTabsForm: boolean = false;
  _gridFieldAuth: GridFieldAuthorization[];
  _isMandatory: boolean = false;
  _requiredFields: Array<any> = [];
  _requiredFieldNames: Array<any> = [];

  _isEditForms: boolean = false;
  //#region custom Fields Fix
  copyModelId: number;
  _customRequiredFields: Array<any> = [];
  //#endregion
  public _donutChartSmall: any[] = [
    {
      data: [{
        category: 'Site 1',
        value: 120,
        color: '#fff6d9',
        colorLabel: '#ae8d2a',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 90,
        color: '#f2e2b1',
        colorLabel: '#ae8d2a',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 210,
      title: 'DC Health'
    },
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e7e0fc',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 40,
        color: '#d1c7f0',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 3',
        value: 120,
        color: '#b3a5e3',
        colorLabel: '#321982',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 180,
      title: 'Safe Workplace'
    },
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e5fadd',
        colorLabel: '#458032',
        font: '10px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 120,
        color: '#abd59d',
        colorLabel: '#458032',
        font: '10px -apple-system, BlinkMacSystemFont'
      }],
      sum: 150,
      title: 'District Logistics Center'
    }
  ];

  public _donutChartLarge: any[] = [
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e5fadd',
        colorLabel: '#458032',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 120,
        color: '#abd59d',
        colorLabel: '#458032',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 150,
      title: 'District Logistics Center'
    }
    ,
    {
      data: [{
        category: 'Site 1',
        value: 30,
        color: '#e7e0fc',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 40,
        color: '#d1c7f0',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 3',
        value: 120,
        color: '#b3a5e3',
        colorLabel: '#321982',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 180,
      title: 'Safe Workplace'
    },
    {
      data: [{
        category: 'Site 1',
        value: 120,
        color: '#fff6d9',
        colorLabel: '#ae8d2a',
        font: '15px -apple-system, BlinkMacSystemFont'
      }, {
        category: 'Site 2',
        value: 90,
        color: '#f2e2b1',
        colorLabel: '#ae8d2a',
        font: '15px -apple-system, BlinkMacSystemFont'
      }],
      sum: 210,
      title: 'DC Health'
    }
  ];
  _currentUser: UserSummary;

  okCloseSubscription: any = null;
  _deactivatedFieldsForm: boolean = false;
  _deactivatedFieldsGridData: any[] = [];
  _NOSActive: boolean = true;
  _INVENTORYIDActive: boolean = false;
  _BCActive: boolean = false;
  StockNumberByDate: any;
  InventoryidnumberInLocationByDate: any;
  QtyItemPerCategoryByDate: any;

  _isDialiog: boolean = false;
  _dialogComponentName: string;
  _dialogModel: any;

  locationTypeChart: Chart;
  _stockItemGridColumns: GridFieldSummary[];
  isOpenStockItemForm: boolean = false;
  reactivate: boolean = false;
  reactivateItem: any;
  isStockItemGridExpanded: boolean = true;
  isStockItemChartExpanded: boolean = true;

  @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
  @ViewChild('kendo_BarcodeGen_Location_Type_ID') kendoBarcodeGenLocationTypeID: ElementRef;
  @ViewChild('locationTypeDescription') locationTypeDescription: ElementRef;
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  @ViewChild('note') note: NoteComponent;

  constructor(
    private _locationTypesService: LocationTypesService,
    private _FacilityServices: FacilityService,
    private _fb: FormBuilder,
    private _themeManager: ThemeManagerService,
    private _layoutManager: LayoutManagerService,
    private _layoutComponent: LayoutComponent,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _securityService: SecurityService,
    private _customFieldsService: CustomFieldsService,
    private _gridFields: GridFieldsService,
    public cdRef: ChangeDetectorRef,
    public _stockItemsService: StockItemsService,
    private _sharedService: SharedService,
    private _formatService: FormatService,

  ) {

    this._getdata();

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
    this._layoutManager.applyOverly();
    this._currentUser = this._securityService.currentUser;

    //this.loadCustomFields(this._model?.id?.toString());
    this.loadLabels();


    this._customFieldsService
      .getDeactivatedCustomFields('stock')

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page);
      });


    if (this._model.id) {
      this._locationTypesService.getStockNumberByDate(this._model.id).subscribe((x: any) => {
        this.StockNumberByDate = x;
      });


      this._locationTypesService.getInventoryidnumberInLocationByDate(this._model.id).subscribe((x: any) => {
        this.InventoryidnumberInLocationByDate = x;
      });

      this._locationTypesService.getQtyItemPerCategoryByDate(this._model.id).subscribe((x: any) => {
        this.QtyItemPerCategoryByDate = x;
      });
    }

    this.getAuth();

    this.clearfeiled = this._gridLayoutManagerService.subscribeToCustomFeildClear();

  }

  _getdata() {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : null;
    this._active = true;

    if (this._pageState === (PageState.ADD || PageState.COPY) && this._model && this._model.id > 0) {
      this.copyModelId = this._model.id;
      this._model.id = null;
      this._model.code = null;
    }



  }

  LoadLocationTypeChart() {
    this._locationTypesService.GetLocationTypeChart(this._model.id)
      .pipe()
      .toPromise()
      .then(async (data: any) => {
        this.locationTypeChart = data;
      });

    this._gridFields
      .getGridFieldsByPage('stockItems')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('stockItems', data);
        this._stockItemGridColumns = data;
      });

  }


  OnOpenStockItemForm(event: any) {
    if ((event.target as HTMLElement).tagName != 'DIV')
      this.isOpenStockItemForm = true;
  }

  OnCloseStockItemForm() {
    this.isOpenStockItemForm = false;
  }


  _getStockItemByLocationType = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._stockItemsService.GetStockItemByLocationType(this._model.id);
  }


  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }


  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }

  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    } else {
      this._editFormActive = true;
      this._isCustomfieldsFormValue = true;
    }
  }
  _NOSTabClick() {

    this._NOSActive = true;
    this._INVENTORYIDActive = false;
    this._BCActive = false;
  }
  _INVENTORYIDTabClick() {
    this._NOSActive = false;
    this._INVENTORYIDActive = true;
    this._BCActive = false;
  }
  _BCTabClick() {
    this._NOSActive = false;
    this._INVENTORYIDActive = false;
    this._BCActive = true;
  }

  _viewInactiveFields() {
    this._customFieldsService
      .getDeactivatedCustomFields('stock')

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page);
      });
    // this._deactivatedFieldsForm = true;
  }
  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }

  _reactivate(item: any) {

    this.reactivateItem = item;
    this.reactivate = true;
    const sub = this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService.reactivateCustomField(this.reactivateItem.id, item)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  //this.loadCustomFields(this._model?.id?.toString());
                  this.getSystemFieldsAndCustomFields();
                  // this._deactivatedFieldsForm = false;
                } else {
                  return;
                }
              }
            }
            // this._deactivatedFieldsForm = false;
          });
        // this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
      sub.unsubscribe();
    });


    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    // this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }

  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }
  _addNewField(tabId: number) {
    this._selectedTabId = null;
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
  }
  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }
  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set

    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }
  _returnAdNew() {
    this._pageState = PageState.ADD;
    if (this._deactivatedFormTabsGridData?.length == 0) {
      this._viewInactiveFormTabs(true);
    }
  }
  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    // this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
  }
  ngOnInit() {
    this._initForm();
    this._viewInactiveFormTabs(true);
    if (this._pageState == PageState.ADD) {
      // setTimeout(() => {
      //   this.kendoBarcodeGenLocationTypeID.nativeElement.focus();
      // }, 500);
    }

    this.getFormTabs();
    //this.getSystemFields();
    this.getSystemFieldsAndCustomFields();

  }
  _barcodeSubmited() {
    this._locationCode.setValue(this._form.get('code').value);
    if (this._pageState == PageState.ADD) {
      // setTimeout(() => {
      //   this.locationTypeDescription.nativeElement.focus();
      // });
    }
  }
  _generateBarcodeClick() {
    this.runGenerateBarcode();
  }
  _openCirclesForm() {
    this._showCirclesForm = true;
    this._tooltipVisibilityUpsert = false;
  }
  _closeCirclesForm() {
    this._showCirclesForm = false;
    this._tooltipVisibilityUpsert = true;
  }

  _edit() {
    this._pageState = PageState.EDIT;
  }
  private runGenerateBarcode() {
    let counter = 1;
    this.generateBarcode(counter)
      .subscribe((data: any) => {
        this._locationCode.setValue(data.result.toString());
        this._form.patchValue({
          code: data.result.toString()
        });
        if (this._pageState == PageState.ADD) {
          setTimeout(() => {
            this.locationTypeDescription.nativeElement.focus();
          });
        }
      });
  }
  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService
      .getBarcode('locationTypes', quantity);
  }

  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;
    if (e === 'minimized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'maximized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'default') {
      element.el.nativeElement.classList.add('fullWidthFormForm');
    }
  }

  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this._innerWidth = window.innerWidth;
    if (this._innerWidth > 450) {
      this._hiddenWindow = 'hidden';
      this._maximized = 'maximized';
    } else {
      this._hiddenWindow = '';
      this._maximized = 'default';
    }
    let windowSize = window.innerWidth;

    if (windowSize <= 991) {
      this._kendoTabStripPosition = 'top';
    } else {
      this._kendoTabStripPosition = 'left';
    }
  }

  _onTabSelect(e: any) {

    this._mobileMenuToggle();
  }

  _mobileMenuToggle() {
    let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
    mobiletabstrip.classList.toggle('visibletab');
  }

  _onSave(e: any) {
    this.submit(e);
  }

  _onCancel() {
    this._closeForm(this._sharedService.model.reload != undefined ? this.modelupdatedlookup : '');
  }
  modelupdatedlookup: any;
  reloadlist: any;
  submodel: any

  _closeForm(poModel: any = null) {

    this.reloadlist = this._sharedService.model.reload;
    this.submodel = this._sharedService.model.submodel;
    var closeComponent = {
      component: 'facility',
      isClosed: true,
      response: this.reloadlist === undefined ? null : poModel
    };

    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects('facility');
    this._layoutManager.setFromChanged('facility');
    this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    if (this.submodel === null || this.submodel === '' || this.submodel === undefined)
      this._sharedService.model = {};

  }


  private _initForm() {
    this._form = this._fb.group({
      code: [this._model ? this._model.code : null, Validators.required],
      description: [this._model ? this._model.description : null, this.getLabel('LBL_LocTypeDesc')?.isRequired ? Validators.required : null],
    });

    if (this._model != null && this._model.id != null && [1, 2, 3].includes(this._model.id)) {
      this._canEditLocationType = false;
    }
  }

  private submit = (e: string) => {
    if (this._form.invalid && this._customValidation.find((x: any) => !x.value)) {
      this._invalidForm = true;
      this._invalidSubmit = true;
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
    } else if (this._form.invalid) {
      this._invalidForm = true;
    } else if (this._customValidation.find((x: any) => !x.value)) {
      this._invalidForm = true;
      this._invalidSubmit = true;
      this._additionalErrors.push("Additional Error");
      this._additionalErrors = [];
    } else {
      // work with custom fields
      if (this._customFieldsValue) {
        //   const entries = Object.entries(this._customFieldsValue);
        //   for (const [index, [key, value]] of entries.entries()) {
        //   let resualt = this._retrieveformcustomfields.filter((a:any)=> a.name === key).shift() ;
        //   //====================Check customFieldType is date type and chang format===================================
        //   if (resualt != undefined && resualt != null && resualt.customFieldType.id === 3 &&  value instanceof Date ) {
        //     const datepipe: DatePipe = new DatePipe('en-US')
        //   let formattedDate = new Date ( datepipe.transform(value, this._formatService.dateFormat))
        // this._customFieldsDictionary[key] = formattedDate.toDateString() + ' ' + formattedDate.toTimeString();
        // //=========================================================================================================
        // }
        // else{
        //   this._customFieldsDictionary[key] = `${value}`;
        // }}
        this._customFieldsValue.forEach((elementy: any) => {
          this._customFieldsDictionary[elementy.Key] = elementy.Value;
        });
      }

      this._invalidForm = false;
      this._invalidSubmit = false;
      const model = this._form.value;
      model['customFieldsValue'] = this._customFieldsDictionary;
      if (!this._model || !this._model.id) {
        this._FacilityServices
          .createFacility(model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  model.id = response.responseId;
                  this._FacilityServices.FacilityAdded.emit(model);
                  if (e === 'saveAndClose') {
                    model.id = response.responseId;
                    this._closeForm(model);
                  }
                  else if (e === 'saveAndCopy') {
                    this._form.controls.code.setValue(null);
                  }
                  else if (e === 'saveAndNew') {
                    this._initForm();
                    this.openUpsert(this._page, {}, PageState.ADD);
                    this._model.id = null;
                    this._form.reset();
                  }
                  else if (e === 'save' || this.reloadlist != undefined) {
                    model.id = response.responseId;
                    this._pageState = PageState.EDIT;
                    this._model.id = response.responseId;
                    this.modelupdatedlookup = model;

                  }
                } else {
                  return;
                }
              }
            }
          });
      } else {
        this._FacilityServices
          .updateFacility(this._model.id, model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                  model.id = this._model.id;
                  this._FacilityServices.FacilityUpdated.emit(model);
                  if (e === 'saveAndClose') {
                    this._closeForm();
                  }
                  else if (e === 'saveAndCopy') {
                    this.copyModelId = this._model.id;
                    this._model.id = null;
                    this._form.controls.code.setValue(null);
                    this._pageState = PageState.ADD;
                    this.loadCustomFields();
                  }
                  else if (e === 'saveAndNew') {
                    //this.openUpsert(this._page, {}, PageState.ADD);
                    this._initForm();
                    this.openUpsert(this._page, {}, PageState.ADD);
                    this._model.id = null;
                    this._form.reset();

                  }
                } else {
                  return;
                }
              }
            }
          });
      }
    }
  }

  _sendcustomFieldsValue: any;
  _retrieveformcustomfields: any;
  private loadCustomFields(entityId?: string) {
    entityId = this.copyModelId?.toString() ?? this._model?.id?.toString();
    this._customFieldsService
      .getCustomFields('stock', this._page, entityId)

      .subscribe((data) => {
        if (this._model != null && this._model.id != null || this.copyModelId != null) {
          let that = this;
          data.map(function (x) {
            x.entityId = that._model.id ?? that.copyModelId;
          });
        }
        this._retrieveformcustomfields = data;
        var tabIds = data.map(item => item.formTabId)
          .filter((value, index, self) => self.indexOf(value) === index);

        const grouped = this.groupBy(data, (item: { formTabId: any }) => item.formTabId);
        let that = this;
        tabIds.forEach(function (formTabId) {

          that._customFields[formTabId] = grouped.get(formTabId);
        });
        if (this.copyModelId) {
          let CustomFieldsDataForCopy: any = {};
          grouped.forEach(element => {
            element.forEach((value: any) => {

              let _cutomfieldData = value.customFieldsData?.find((f: any) => f.entityId == entityId);
              CustomFieldsDataForCopy[value.name] = _cutomfieldData?.value ?? null;
              if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
              if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name])
                CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
            });
            this._customFieldsValueChanges(CustomFieldsDataForCopy, null);

          });
        }
        this._customFieldsService
          .getFormTabsByPage(this._page)

          .subscribe((data: any) => {
            //get custom tabs first
            this._customTabs = data.filter(
              (x: { isCustom: boolean }) => x.isCustom == true
            );
            this.setMandatoryFields();
          });
      });


  }

  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  customFieldsValuearray: any = {};

  // _customFieldsValueChanges(customFieldsValue: any, tabId: number) {

  //   Object.keys(customFieldsValue).forEach(key => {
  //     if (customFieldsValue[key] == null || customFieldsValue[key] == 'null') {
  //       customFieldsValue[key] = '';
  //     }
  //     let getcustomFields = this._customFields[tabId].find(x => x.name == key) ;

  //     if(getcustomFields != undefined) {
  //     if (this._customFields[tabId].find(x => x.name == key).entityId == undefined) {//new mode, custom field data not added yet
  //       this._customFields[tabId].find(x => x.name == key).entityId = -1;
  //       this._customFields[tabId].find(x => x.name == key).customFieldsData.push({ id: -1, value: 'null', entityId: -1,customFieldId:-1 });
  //     }
  //     var customFieldData = this._customFields[tabId].find(x => x.name == key).customFieldsData.find(x => x.entityId == this._customFields[tabId].find(x => x.name == key).entityId);
  //     if (customFieldData != undefined) {
  //       customFieldData.value = customFieldsValue[key];
  //     }
  //   }
  //   });

  //     const entries = Object.entries(customFieldsValue);
  //         for (const [index, [key, value]] of entries.entries()) {
  //                   this.customFieldsValuearray[key]  = value
  //         }
  //  this._customFieldsValue = this.customFieldsValuearray ; //customFieldsValue;


  // }
  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {

    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };
      let item = null;
      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });
      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);
        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }
      var requiredCustomerField = this._customValidation.find(
        (x: any) => x.name == key
      );
      if (requiredCustomerField) {
        let item2 = null;
        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });
        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);
          if (index2 != -1) {
            //this._customValidation.splice(index2, 1);
            this._customValidation[index2].value = customObject.Value;
          }
          //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
        }
      }
      this._additionalErrors = [];
      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }

      this._customFieldsValue.push(customObject);
    });
  }

  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (this._customFields[i].findIndex(x => x.id == customFieldId) != -1) {
          this._customFields[i] = this._customFields[i].filter(x => x.id != customFieldId);
          return;
        }
      }
    }
  }
  _viewInactiveFormTabs(onLoad: boolean = false) {
    this._customFieldsService
      .getDeactivatedCustomForms(this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFormTabsGridData = data;
        //  if(!onLoad)
        //  this._deactivatedFormTabsForm = true;
      });
  }
  reactivateTab: boolean;
  _reactivateFormTab(item: any) {
    this.reactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      this.reactivateTab = true;
      if (boolData && this.reactivateTab) {
        // if (boolData && this.reactivateTab && (this.lastTabIdReactivated.length == 0 || !this.lastTabIdReactivated.includes(item.id))) {
        this.reactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService
          .reactivateFormTab(item.id, model)

          .subscribe((response: any) => {
            if (response != null && response['message'] != null) {
              // if (this.lastTabIdDeactivated.includes(item.id)) {
              //   this.lastTabIdDeactivated = this.lastTabIdDeactivated.filter(id => id !== item.id);
              // }
              // this.lastTabIdReactivated.push(item.id);
              this._viewInactiveFormTabs(false)
              this._customFieldsService
                .getFormTabsByPage(this._page)

                .subscribe((data: any) => {
                  //get custom tabs first
                  this.getFormTabs();
                  this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
                });
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              if (response['close'] != null) {
                if (response['close'] == true) {
                } else {
                  return;
                }
              }
            }
          });
      } else {
        this.reactivateTab = false;
      }
      sub.unsubscribe();
    });


    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
  }
  _closeInactiveFormTabs() {
    this._deactivatedFormTabsForm = false;
  }
  // lastTabIdDeactivated:number[] = []
  // lastTabIdReactivated:number[] = []
  //#endregion
  deactivateTab: boolean
  _deactivateTab(tabId: number, page: string) {
    this.deactivateTab = true;
    const sub = this._sharedService.okCloseClicked.subscribe((boolData: boolean) => {
      if (boolData && this.deactivateTab) {
        // if (boolData && this.deactivateTab && (this.lastTabIdDeactivated.length == 0 || !this.lastTabIdDeactivated.includes(tabId))) {
        this.deactivateTab = false;
        let model: any = {
          customFieldEntityId: 1,
          page: this._page,
          accountIds: this._selectedAccountIds,
        };
        this._customFieldsService.deleteCustomTab(tabId, model).subscribe((response: any) => {
          // this.lastTabIdDeactivated.push(tabId);
          // if (this.lastTabIdReactivated.includes(tabId)) {
          //   this.lastTabIdReactivated = this.lastTabIdReactivated.filter(id => id !== tabId);
          // }

          if (response != null && response['message'] != null) {
            this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
              //get custom tabs first
              this.getFormTabs();
              this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
            });

            this._layoutComponent.openPopup({
              title: 'Alert',
              message: response['message'],
              withoutConfirm: true
            });

            if (response['close'] != null) {
              if (response['close'] == true) {
                // this._closeForm();
              }
              else {
                return;
              }
            }
          }
        });
      } else {
        this.deactivateTab = true;
      }
      sub.unsubscribe();
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Deactivate This Tab?',
    });

  }


  // _deactivateTab(tabId: number, page: string) {

  //   let model: any = {
  //     customFieldEntityId: page == 'facility' ? 1 : 2,
  //     page: this._page,
  //     accountIds: this._selectedAccountIds,
  //   };
  //     .deleteCustomTab(tabId, model)
  //     
  //     .subscribe((response: any) => {
  //       if (response != null && response['message'] != null) {
  //           .getFormTabsByPage(this._page)
  //           
  //           .subscribe((data: any) => {
  //             //get custom tabs first
  //             this._customTabs = data.filter((x: { isCustom: boolean }) => x.isCustom == true);
  //           });
  //         this._layoutComponent.openPopup({
  //           title: 'Alert',
  //           message: response['message'],
  //           withoutConfirm: true
  //         });
  //         if (response['close'] != null) {
  //           if (response['close'] == true) {
  //             // this._closeForm();
  //           } else {
  //             return;
  //           }
  //         }
  //       }
  //       //   this._closeForm();
  //     });

  // }

  private loadLabels() {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language)

      .subscribe((data: GridFieldTextSummary[]) => {
        this._gridFieldText = data;
        this._initForm();
      });
  }

  getLabel(objectCode: any) {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      else
        result = null;

      return result ? result : null;
    }
  }

  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }


  CheckIfWeAreInEditMode() {
    var isEditMode: boolean = false;
    if (this._pageState == PageState.EDIT) {
      isEditMode = true;
    }

    return isEditMode;
  }


  _reorderingtabs() {
    this._orderingTabsForm = true;
  }
  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }


  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find(x => x.order == i + 1)) {
      this._userNewDataTabs.find(x => x === this._dataTabsSelected.find(x => x.order == i + 1)).order =
        this._dataTabsSelected.find(x => x.name === e.name).order;
    }
    this._userNewDataTabs.find(obj => obj.name == e.name).order = i + 1;
    this._dataTabsSelected = this._dataTabsSelected.filter(obj => obj !== e);
  }

  _onSaveTabOrdering() {
    this._gridFields.updateFormTabsReorder(this._userNewDataTabs)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._closeOrderingTabsForm();
      });
  }

  getFormTabs() {
    this._gridFields.getformTabsByPage(this._page)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._userNewDataTabs = x;
        //this.sortProduct(p => p.order, "ASC");
      });
  }

  getAuth() {
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id)

      .subscribe((x: GridFieldAuthorization[]) => {
        this._gridFieldAuth = x;
      });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode))
        var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      else
        result = null;

      return result ? result : new GridFieldAuthorization();
    }
  }

  getSystemFields() {
    this._gridFields.getSystemFieldsByPage(this._page)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
      });
  }
  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page)

      .subscribe((x: any) => {
        this._systemFields = x;
        this._editedSystemFields = x;
        this.loadCustomFields(this._model?.id?.toString());
        //this.setMandatoryFields();
      })

  }
  //#region  setMandatoryFields
  requiredSystemTabs: any = [];
  setMandatoryFields() {
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];
    setTimeout(() => {
      for (let item of this._systemFields) {
        if (item.gridFieldText.isRequired) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired) {
              this._requiredFields.push(item3);
            }
          }
        }
      }
      this._requiredFields.forEach(element => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);
            if (SystemFieldTab)
              this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });
      if (this.navTrigger) {
        let tabElementList = this.navTrigger.nativeElement.querySelector('ul');
        Array.from(tabElementList.children).forEach((child: any) => {

          child.classList.remove('mendatoryTab');
        });
        Array.from(tabElementList.children).forEach((child: any) => {

          if (this._requiredFieldNames.find(x => x.name === child.firstChild.innerText && (x.page ? x.page == this._page : x.formtab.page == this._page))) {
            child.classList.add("mendatoryTab")
          }
          if (
            this.requiredSystemTabs.find(
              (x: any) =>
                x.name === child.firstChild.innerText
            )
          ) {
            child.classList.add('mendatoryTab');
          }
        });
      }
      this._requiredFields.forEach((element) => {
        if (element.customFieldType) {
          this._customRequiredFields.push(element);
          let thisvalue =
            element.customFieldsData.filter(
              (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
            ).length > 0
              ? element.customFieldsData.filter(
                (x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)
              )[0].value
              : '';
          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });
        }
      });


    }, 500);

  }
  //#endregion

  _onEditForms() {
    this._isEditForms = true;
  }

  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }

  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState };
    this.clearCustomeFeiled();
  }

  clearCustomeFeiled() {
    this.clearfeiled.next('clear');
  }

  _closeDialog(event: boolean) {
    this._isDialiog = event;
  }





  ExpandCollapseStockItemGrid(isExpand: boolean) {
    this.isStockItemGridExpanded = !isExpand;
  }


  ExpandCollapseStockItemChart(isExpand: boolean) {
    this.isStockItemChartExpanded = !isExpand;
  }




  getStockItemLeadsString(stockItemLeads: any) {
    let leads = '';
    let counter = 0;
    stockItemLeads.forEach((element: any) => {
      if (counter > 0) {
        leads += ', ';
      }
      leads += element.stockitemleadtime;
      counter++;
    });
    return leads;
  }

  getStockImage(stockItemFiles: any) {
    let files = '';
    let counter = 0;
    stockItemFiles.forEach((element: any) => {
      if (counter > 0) {
        files += ', ';
      }
      files += element.file.thumbnail;
      counter++;
    });
    return files;
  }

  getCategoryImage(categoryFiles: any) {
    let catfiles = '';
    let counter = 0;
    categoryFiles.forEach((element: any) => {
      if (counter > 0) {
        catfiles += ', ';
      }
      catfiles += element.file.thumbnail;
      counter++;
    });
    return catfiles;
  }

  getVendors(vendors: any) {
    let vendor = '';
    let counter = 0;
    vendors.forEach((element: any) => {
      if (counter > 0) {
        vendor += ', ';
      }
      vendor += element.vendorid;
      counter++;
    });
    return vendor;
  }

  getTimeUnitCode(vendors: any) {
    let vendor = '';
    let counter = 0;
    vendors.forEach((element: any) => {
      if (counter > 0) {
        vendor += ', ';
      }
      vendor += element.stockItemLeadid;
      counter++;
    });
    return vendor;
  }

  getTimeUnit(vendors: any) {
    let vendor = '';
    let counter = 0;
    vendors.forEach((element: any) => {
      if (counter > 0) {
        vendor += ', ';
      }
      vendor += element.stockitemleadinterval;
      counter++;
    });
    return vendor;
  }


  getSitesString(accountSites: any, isId: boolean) {
    let sites = '';
    let counter = 0;
    accountSites.forEach((element: any) => {
      if (counter > 0) {
        sites += ', ';
      }
      if (!isId) {
        if (element.site) {
          sites += element.site.name;
        } else {
          sites += 'All Sites';
        }
      }
      else {
        if (element.site) {
          sites += element.site.id;
        }
      }

      counter++;
    });
    return sites;
  }

  getAccountsString(accountSites: any) {
    let accounts = '';
    let counter = 0;
    accountSites.forEach((element: any) => {
      if (counter > 0) {
        accounts += ', ';
      }
      accounts += element.account.name;
      counter++;
    });

    return accounts;
  }

  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }

  _hasCustomTabs() {
    return this._dataTabs.find((x: any) => x.isCustom);
  }
}
